<script lang="ts">
	import Icon from '../icon/Icon.svelte'
	import { ChevronDown } from '@steeze-ui/heroicons'
	import { createEventDispatcher } from 'svelte'
	import { fade, slide } from 'svelte/transition'

	interface Props {
		title?: string
		expanded?: boolean
		border?: boolean
		noPadding?: boolean
		noMargin?: boolean
		smallPadding?: boolean
		rightArrow?: boolean
		contentClass?: string
		hideArrow?: boolean
		id?: any
		small?: boolean
		noBorderTop?: boolean
		info?: import('svelte').Snippet
		toolbar?: import('svelte').Snippet
		placeholder?: import('svelte').Snippet
		actions?: import('svelte').Snippet
		children?: import('svelte').Snippet
	}

	let {
		title = '',
		expanded = $bindable(true),
		border = false,
		noPadding = false,
		noMargin = false,
		smallPadding = false,
		rightArrow = false,
		contentClass = '',
		hideArrow = false,
		id = `accordion-${Math.random().toString(36).substring(2, 7)}`,
		small = false,
		noBorderTop = false,
		info,
		toolbar,
		placeholder,
		actions,
		children,
	}: Props = $props()

	const buttonId = `${id}-button`

	const dispatch = createEventDispatcher()

	function handleClick() {
		expanded = !expanded
		dispatch('toggle', { id, expanded })
	}
</script>

<div>
	<div
		class="flex items-center gap-2.5 {border
			? `${noBorderTop ? '' : 'border-t border-t-gray-200 pt-2 dark:border-t-gray-700'}`
			: ''}"
	>
		<button
			id={buttonId}
			class="flex w-full items-center gap-x-1 text-left text-gray-900 target:outline-hidden dark:text-white {border
				? ''
				: noPadding
					? ''
					: smallPadding
						? 'py-3'
						: 'py-7'}"
			aria-controls={id}
			aria-expanded={expanded}
			onclick={handleClick}
			type="button"
		>
			{#if !rightArrow && !hideArrow}
				<span class="flex {expanded ? 'rotate-180' : ''}">
					<Icon src={ChevronDown} />
				</span>
			{/if}
			<span class="flex flex-1 items-center {small ? '' : 'text-lg'}">
				{#if title}
					<span class="mr-2 block font-bold">
						{title}
					</span>
					{@render info?.()}

					{#if expanded && toolbar}
						<div
							class="ml-auto flex items-center gap-3 md:-my-4"
							transition:fade|local={{ duration: 300 }}
						>
							{@render toolbar?.()}
						</div>
					{/if}
				{:else}
					{@render placeholder?.()}
				{/if}
			</span>

			{#if rightArrow && !hideArrow}
				<span class="ml-3 flex {expanded ? 'rotate-180' : ''}">
					<Icon src={ChevronDown} />
				</span>
			{/if}
		</button>
		{@render actions?.()}
	</div>

	{#if expanded}
		<div
			{id}
			class="text-base {contentClass}"
			aria-labelledby={buttonId}
			role="region"
			transition:slide|local={{ duration: 300 }}
		>
			{#if border}
				<div class="pt-4"></div>
			{/if}
			{@render children?.()}
		</div>
	{:else}
		<!-- Render hidden, so that nested form elements are still considered for form submission validation. -->
		<div class="hidden">
			{@render children?.()}
		</div>
	{/if}

	{#if border}
		<div class={expanded ? 'mt-4' : 'mt-2'}></div>
	{:else if expanded && !noPadding && !noMargin}
		<div class="mt-7"></div>
	{/if}
</div>
